import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyADNfMw4VQ3oTK-kVM8hc9MmVNrKsgNsrw",
    authDomain: "chalkolate-stage.firebaseapp.com",
    projectId: "chalkolate-stage",
    storageBucket: "chalkolate-stage.firebasestorage.app",
    messagingSenderId: "804567074224",
    appId: "1:804567074224:web:f9bfa4d4c3153d98158275",
    measurementId: "G-TDEVFQBKZM"
  };
  
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 